import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { isAuthenticated, logout } = useAuth();

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    logout();
    setIsOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="container navbar-container">
        <Link to="/" className="navbar-logo">
          <img src="/logo.png" alt="Hosan Logo" className="navbar-logo-img" />
          <span className="navbar-brand">HOSAN</span>
        </Link>

        <button 
          className={`navbar-toggle ${isOpen ? 'active' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`navbar-menu ${isOpen ? 'active' : ''}`}>
          <Link 
            to="/" 
            className={`navbar-link ${isActive('/') ? 'active' : ''}`}
            onClick={() => setIsOpen(false)}
          >
            Inicio
          </Link>
          <Link 
            to="/productos" 
            className={`navbar-link ${isActive('/productos') ? 'active' : ''}`}
            onClick={() => setIsOpen(false)}
          >
            Productos
          </Link>
          <Link 
            to="/servicios" 
            className={`navbar-link ${isActive('/servicios') ? 'active' : ''}`}
            onClick={() => setIsOpen(false)}
          >
            Servicios
          </Link>
          <Link 
            to="/nosotros" 
            className={`navbar-link ${isActive('/nosotros') ? 'active' : ''}`}
            onClick={() => setIsOpen(false)}
          >
            Nosotros
          </Link>
          <Link 
            to="/contacto" 
            className={`navbar-link ${isActive('/contacto') ? 'active' : ''}`}
            onClick={() => setIsOpen(false)}
          >
            Contacto
          </Link>
          
          {isAuthenticated && (
            <>
              <Link 
                to="/admin" 
                className={`navbar-link navbar-link-admin ${isActive('/admin') ? 'active' : ''}`}
                onClick={() => setIsOpen(false)}
              >
                Admin
              </Link>
              <button 
                onClick={handleLogout}
                className="navbar-link navbar-link-logout"
              >
                Salir
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
